import { assert } from '../../../lib/assert-sidecar'
import { l } from '../../../lib/imports'
import { voyageColors } from '../voyageColors-sidecar'
import { voyageCrew } from '../voyageCrew-sidecar'
import { voyageCrew_movable } from '../voyageCrew_movable-sidecar'
import { voyageMovementIndicators } from '../voyageMovementIndicators-sidecar'
import { EVoyageMessage } from './voyageMessageIds'

import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'

export interface IMessageCrewMove {
  crewId: number
  // si: number
  // sj: number
  path: [number, number][]
}

export const voyageMessageId = EVoyageMessage.CrewMove

export function write(m: IMessageWriter, d: IMessageCrewMove) {
  messageWriter.write8(m, voyageMessageId)
  messageWriter.write32(m, d.crewId)
  // messageWriter.write16(m, d.si)
  // messageWriter.write16(m, d.sj)
  let len = d.path.length
  messageWriter.write16(m, len)
  for (let i = 0; i < len; i++) {
    let p = d.path[i]
    messageWriter.write16(m, p[0])
    messageWriter.write16(m, p[1])
  }
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, voyageMessageId)

  let d: IMessageCrewMove = {
    crewId: messageWriter.read32(m),
    path: [],
  }

  let len = messageWriter.read16(m)
  for (let i = 0; i < len; i++) {
    d.path.push([messageWriter.read16(m), messageWriter.read16(m)])
  }

  return d
}

export function test() {
  let ex: IMessageCrewMove = {
    crewId: 100,
    path: [
      [1, 2],
      [3, 4],
    ],
  }
  messageWriter.test('crew-move', ex, write, read)
}

export function process(m: IMessageWriter) {
  let msg = read(m)
  let cr = voyageCrew.findById(msg.crewId)
  assert.notNil(cr)
  voyageCrew_movable.networkRecievePathTo(cr, msg)

  if (msg.path.length > 0) {
    let mi = voyageMovementIndicators.create(voyageColors.red)
    let lastPath = msg.path[msg.path.length - 1]
    voyageMovementIndicators.moveToIJ(mi, { i: lastPath[0], j: lastPath[1] })
  }
}

export function SendMessageRequestAndImmediatelyExecute_NonHost(
  msg: IMessageCrewMove,
) {
  websockets._sendMessageAndImmediatelyExecute_nonHost(write, msg)
}
